import {
    Insurance,
    InsuranceDetailsAthena
} from 'one-state-insurance';


import {
    FhirInsuranceDetails
} from 'one-state-fhirinsurance/src/fhirinsurance-details';


export const TransformInsuranceDetails = (response: any, context: any) => {

    let insurancedata: Insurance[] = [];
    let insuranceresult: any = {
        insurancedata: insurancedata,
        error: undefined
    }
    const { log } = context;
    log.debug("one-epic", "TransformInsuranceDetails transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        insuranceresult.error = response;
    }
    if (response && response.length > 0) {
        response.map((ele: any) => {
            if(ele?.insurances?.length > 0) {
                let insurance: Insurance = {
                    planname:null,
                    groupnumber: null,
                    employername: null,
                    employercity: null,
                    empcontact: null,
                    insurancedetailsath: undefined
                };
                let insurancelist: InsuranceDetailsAthena[] = [];
                insurance.employername = ele?.employername ? ele.employername : "";
                insurance.employercity = ele?.employercity? ele.employercity : "" ;
                insurance.empcontact = ele?.employerphone ? ele.employerphone : ""; 
                ele.insurances.forEach((insdata:any)=>{
                    

                    let insobj:InsuranceDetailsAthena = {
                        planname: insdata?.insuranceplanname ? insdata.insuranceplanname : "",
                        policyid :insdata?.insuranceidnumber ? insdata.insuranceidnumber : "",
                        effectivefromdate: insdata?.issuedate ? insdata.issuedate : "",
                        groupnumber: insdata?.policynumber ? insdata.policynumber : "",
                        producttype: insdata?.ircname ? insdata.ircname : "",
                        eligibilitystatus: insdata?.eligibilitystatus ? insdata.eligibilitystatus : ""
                    }
                    insurancelist.push(insobj)
                })
                insurance.insurancedetailsath = insurancelist;
                insurancedata.push(insurance)
            }
        });
    }
    insuranceresult.insurancedata = insurancedata;
    log.debug("one-epic", "TransformInsuranceDetails transformation Completed", insuranceresult);
    return insuranceresult;
}

export const TransformFHIRDetails = (response: any, context: any) => {
    /**
    * @param result contains the transformed response
    */
    
    
        let result: any = {
            fhircoverage: [],
            error: undefined
        }
    
        const { log } = context;
        // TODO:verify backend team check for errors
        if (response && (response.status >= 400 || response.type == "error")) {
            result.error = response;
        }
    
        if (response && response.length > 0) {
            const rs = response;
            let coveragearray: FhirInsuranceDetails[] = [];
            rs.forEach((ele: any) => {
                let coverageobj: FhirInsuranceDetails = {
                    payor: "",
                    subscriberid: "",
                    startdate: "",
                    enddate: "",
                    status: ""
                }
                if (ele?.entry && ele.entry.length > 0) {
                    ele.entry.forEach((identifierdata: any) => {
                        coverageobj.status = identifierdata?.status ? identifierdata.status : "";
                        coverageobj.subscriberid = identifierdata?.subscriberId ? identifierdata.subscriberId : "";
                        coverageobj.startdate = identifierdata?.period?.start ? identifierdata.period.start : "";
                        coverageobj.enddate = identifierdata?.period?.end ? identifierdata.period.end : "";
                        if(identifierdata?.payor) {
                            identifierdata.payor.forEach((payordata: any) => {
                                coverageobj.payor = payordata?.display ? payordata.display : "";
                            })
                        }
                    })
                }
                coveragearray.push(coverageobj);
            });
            result.fhircoverage = coveragearray;
        }
        log.debug(
            "ccw-gadget,patientFHIR-epic",
            "patientFHIR-epic transforamtion response ", {
            result
        });
    
        return result;
    }